import React from 'react';
import { Icon, Image, Link, Title } from '@landing/ui';

import * as styles from './LocationCard.module.scss';

export default function LocationCard({ title, date, link, image, finished }) {
  const Wrapper = link ? Link : 'div';

  return (
    <Wrapper className={styles.card} href={link} target={null}>
      <Image className={styles.picture} classImage={styles.img} src={image} />
      <div className={styles.contentWrapper}>
        {finished && <div className={styles.tag}>Finished</div>}
        <Title className={styles.title} tag="h3" color="white">
          {title}
        </Title>
        <div className={styles.details}>
          <div className={styles.date}>
            <Icon name="calendar" className={styles.dateIcon} />
            <span>{date}</span>
          </div>
          {link && <span className={styles.link}>Event details</span>}
        </div>
      </div>
    </Wrapper>
  );
}
